import React, { RefObject } from "react";
import { useTranslate } from "@refinedev/core";
import { Button, Divider, Grid2 as Grid, Typography } from "@mui/material";

import { Form, ModalRef } from "@shared/components";

export const BasicFields = React.memo(({
  isEditing,
  changePasswordModalRef
}: { isEditing?: boolean, changePasswordModalRef: RefObject<ModalRef> }) => {
  const translate = useTranslate();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="full_name"
          label={translate("v1/user_admin.fields.full_name")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="email"
          label={translate("v1/user_admin.fields.email")}
          required
        />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.Input
          name="cpf"
          label={translate("v1/user_admin.fields.cpf")}
          mask="cpf"
          required
        />
      </Grid>

      {!isEditing && (
        <Grid size={{ xs: 12 }}>
          <Form.Input
            type="password"
            name="password"
            label={translate("v1/user_admin.fields.password")}
            required
          />
        </Grid>
      )}

      {isEditing && (
        <Grid size={{ xs: 12 }}>
          <Button
            type="button"
            variant="outlined"
            color="primary"
            onClick={() => changePasswordModalRef.current?.open()}
          >
            {translate("v1/user_admin.buttons.change_password")}
          </Button>
        </Grid>
      )}

      <Grid size={{ xs: 12 }}>
        <Divider />
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography style={{ fontSize: 14, color: "primary.main" }}>
          {translate("v1/user_admin.fields.image")}
        </Typography>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Form.SinglePhotoPicker name="image" />
      </Grid>
    </Grid>
  );
});
